import React from 'react';
import { handleKeyDown } from '../../specific/PurposeAssessment/AssessmentForm/commonUtils';
import * as ObjectExtensions from '../../../utils/CoreExtensions/ObjectExtensions';
import { getEventDetails, eventTracker } from './eventTracker';

const ChrLink = props => {
  const {
    anchorTag,
    onClick,
    isLinkOnClick = true,
    href,
    newTab,
    noHref,
    data,
    htmlId,
    className,
    eventDetails,
    trackClick,
    ...extraProps
  } = props

  const asLink = (anchorTag || (onClick && isLinkOnClick) || href);
  const LinkComponent = asLink ? `a` : `span`;
  const target = (href && newTab) ? "_blank" : null;
  const refinedHref = (href) || (noHref ? null : "#")
  const { eventName, payload } = getEventDetails(eventDetails);
  const onClickTracker = () => eventTracker(eventName, payload);
  const getRefinedOnClick = (existingOnClick) => {
    let onClicks = [];
    if(trackClick) {
      onClicks = [...onClicks, onClickTracker]
    }
    if(existingOnClick) {
      onClicks = [...onClicks, existingOnClick]
    }
    return (...args) => { onClicks.map(onClickFn => onClickFn(...args)) }
  }
  let componentOptions = { onClick: getRefinedOnClick() };
  let htmlData = data ? ObjectExtensions.objectToHtmlDataAttributesMap(data) : {};

  if (asLink) {
    componentOptions = {
      target: target,
      href: refinedHref,
      onClick: getRefinedOnClick(onClick),
      id: htmlId,
      ...(refinedHref === null && { tabIndex: 0, role: 'button' })
    };
  }

  return (
    <LinkComponent
      className={ className }
      onKeyDown={ handleKeyDown }
      {...htmlData}
      { ...componentOptions }
      {...extraProps}
    >
      { props.children }
    </LinkComponent>
  );
};

export default ChrLink;